import { render, staticRenderFns } from "./vehicle-profit.detail.vue?vue&type=template&id=337c64e2"
import script from "./vehicle-profit.detail.vue?vue&type=script&lang=js"
export * from "./vehicle-profit.detail.vue?vue&type=script&lang=js"
import style0 from "./vehicle-profit.detail.vue?vue&type=style&index=0&id=337c64e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports